import * as React from "react";
import Box from "@mui/material/Box";
import axios from "axios";
import { genURL } from "../../_getjson";
import CustomDataGrid from "../../Components/CustomDataGrid/CustomDataGrid";
import CustomBackdrop from "../../Components/CustomBackdrop/Barckdrop";
import CustomInput from "../../Components/CustomInput/CustomInput";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import {
  blackColor,
  defaultFont,
  grayColor,
} from "../../assets/jss/psstyle/psacount";
import { Paper, Popper, Typography } from "@mui/material";
import PropTypes from "prop-types";

function isOverflown(element) {
  return (
    element.scrollHeight > element.clientHeight ||
    element.scrollWidth > element.clientWidth
  );
}
const GridCellExpand = React.memo(function GridCellExpand(props) {
  const { width, value } = props;
  const wrapper = React.useRef(null);
  const cellDiv = React.useRef(null);
  const cellValue = React.useRef(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [showFullCell, setShowFullCell] = React.useState(false);
  const [showPopper, setShowPopper] = React.useState(false);

  const handleMouseEnter = () => {
    const isCurrentlyOverflown = isOverflown(cellValue.current);
    setShowPopper(isCurrentlyOverflown);
    setAnchorEl(cellDiv.current);
    setShowFullCell(true);
  };

  const handleMouseLeave = () => {
    setShowFullCell(false);
  };

  React.useEffect(() => {
    if (!showFullCell) {
      return undefined;
    }

    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === "Escape" || nativeEvent.key === "Esc") {
        setShowFullCell(false);
      }
    }

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [setShowFullCell, showFullCell]);

  return (
    <Box
      ref={wrapper}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      sx={{
        alignItems: "center",
        lineHeight: "24px",
        width: "100%",
        height: "100%",
        position: "relative",
        display: "flex",
      }}
    >
      <Box
        ref={cellDiv}
        sx={{
          height: "100%",
          width,
          display: "block",
          position: "absolute",
          top: 0,
        }}
      />
      <Box
        ref={cellValue}
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          fontFamily: "Customfont !important",
        }}
      >
        {value}
      </Box>
      {showPopper && (
        <Popper
          open={showFullCell && anchorEl !== null}
          anchorEl={anchorEl}
          style={{ width, marginLeft: -17 }}
        >
          <Paper
            elevation={1}
            style={{ minHeight: wrapper.current.offsetHeight - 3 }}
          >
            <Typography
              variant="body2"
              style={{ padding: 8 }}
              sx={{
                fontFamily: "Customfont !important",
                whiteSpace: "normal",
                wordBreak: "break-word",
              }}
            >
              {value}
            </Typography>
          </Paper>
        </Popper>
      )}
    </Box>
  );
});

GridCellExpand.propTypes = {
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

function renderCellExpand(params) {
  return (
    <GridCellExpand
      value={params.value || ""}
      width={params.colDef.computedWidth}
    />
  );
}

const columns = [
  { field: "id", headerName: "id", width: 40, hide: true },
  {
    field: "code",
    headerName: "รหัส",
    width: 200,
    editable: false,
    renderCell: renderCellExpand,
  },
  {
    field: "nameth",
    headerName: "ชื่อ/คำอธิบาย",
    width: 300,
    editable: false,
    flex: 1,
    renderCell: renderCellExpand,
  },
];

export default function DataGridCSMSTRIGTH(props) {
  const [openbackdrop, setopenbackdrop] = React.useState(false);
  const [rows, setRows] = React.useState([]);
  const [Inputtext, setInputtext] = React.useState("");
  React.useEffect(() => {
    loadData("all");
    return () => {};
  }, []);
  const loadData = async (val) => {
    setopenbackdrop(true);
    let url = "";
    if (val === "all") {
      url = "csmstright/GETALL?top=300";
    } else {
      url = `csmstright/GETALL?top=300&txt=${Inputtext}`;
    }

    let rs = await axios.get(genURL(url), { timeout: 12000 });
    let element = [];
    await console.log("elementzzzzzzzzzzz genURL(url)", genURL(url));
    if (rs.data.length > 0) {
      // console.log("rs", rs.data);
      for (let index = 0; index < rs.data.length; index++) {
        element.push({
          id: Number(index) + 1,
          code: rs.data[index].CODE,
          nameth: rs.data[index].MYNAMETH,
        });
        // console.log("rs elementzzzzzzzzzzz", rs.data[index].code);
      }
      // await setusedata(element)
      await setRows(element);
    } else {
      await setRows([]);
    }
    await setopenbackdrop(false);
  };

  const resData = (e) => {
    //    console.log("resData resData", e)
  };
  const removeresData = (e) => {
    console.log("resData removeresData", e);
  };
  const selcetRow = (e) => {
    // await setopenbackdrop(true)
    // await
    props.Dataselect(e);
    // await setopenbackdrop(false)
    console.log("selcetRow", e);
  };
  const resinput = (e) => {
    setInputtext(e);
  };
  const keyDown = (e) => {
    console.log(e);
    if (e === "Enter") {
      loadData("search");
    }
  };
  return (
    <Box sx={{ height: 500, width: "100%" }}>
      <Stack direction="row" spacing={0} mt={1} mb={1}>
        <CustomInput
          label={"คำค้น"}
          resData={(e) => resinput(e)}
          inputType={"text"}
          keyDown={(e) => keyDown(e)}
        />

        <Button
          variant="outlined"
          startIcon={<SearchRoundedIcon />}
          sx={{
            pt: -5,
            height: "32px",
            mt: 1.4,
            borderColor: grayColor[11],
            color: blackColor[0],
            fontFamily: defaultFont,
          }}
          onClick={(e) => loadData("search")}
        >
          ค้นหา
        </Button>
      </Stack>

      {rows.length > 0 ? (
        <CustomDataGrid
          datacolumns={columns}
          datarows={rows}
          rowHeight={38}
          Dataintable={(e) => resData(e)}
          Dataintableremove={(e) => removeresData(e)}
          startRow={1}
          option={[{ add: false, del: false, select: true }]}
          checkboxSelection
          Dataselect={(e) => selcetRow(e)}
          RowsModelChange={(_) => console.log("RowsModelChange")}
        />
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} textAlign={"center"}>
            ไม่พบข้อมูล
          </Grid>
        </Grid>
      )}
      <CustomBackdrop open={openbackdrop} />
    </Box>
  );
}
